<template>
	<div class="card card-accent-success mb-3">
		<div class="card-header px-3 py-2">
			<i class="far fa-list-alt fa-lg mr-2"></i>
			{{ __('translations.title.metadata') }}
		</div>
		<div class="card-body p-3">
			<form autocomplete="off">
				<div class="form-group row">
					<div class="col-12">
						<input type="text" v-model="form.label" :list="randomId" class="form-control form-control-sm metadata-label" placeholder="Sélectionner ou entrer le label"  maxlength="255" ref="label" />
						<datalist :id="randomId">
					      	<option v-for="(label, index) in metadataLabels">{{ label }}</option>
					    </datalist>
					    <div v-if="errors && errors.label" class="text-danger"><small>{{ errors.label[0] }}</small></div>
					</div>
				</div>
				<div class="form-group row">
					<div class="col-12">
						<input type="text" class="form-control form-control-sm" name="metadata_value" v-model="form.value" :placeholder="__('translations.label.value')" maxlength="255" />
						<div v-if="errors && errors.value" class="text-danger"><small>{{ errors.value[0] }}</small></div>
					</div>
				</div>
				<div class="form-group row mb-0">
					<div class="col">
						<button v-if="!isEditing" type="submit" @click.prevent="save" class="btn btn-sm btn-success" :disabled="form.label === '' || form.value === ''">{{ __('translations.button.add') }}</button>
						<button v-else type="submit" @click.prevent="finishEditing" class="btn btn-sm btn-success" :disabled="form.label === '' || form.value === ''">{{ __('translations.button.save') }}</button>
						<button type="button" class="btn btn-sm btn-light" @click="resetForm">{{ __('translations.button.cancel') }}</button>
					</div>
				</div>
			</form>
			<hr v-if="source.metadatas.length > 0" />
			<transition-group v-if="source.metadatas.length > 0" name="metadata" tag="ul" class="list-group list-group-flush metadata-list">
           		<li v-for="metadata in source.metadatas" :key="metadata.id" class="list-group-item d-flex justify-content-between align-items-center px-0 py-2">
					<template>
						<span class="list-group-item-action">
							<p class="mb-0"><b>{{ metadata.label }}</b></p>
							<p class="text-muted mb-0">{{ metadata.value }}</p>
						</span>
						<div v-show="currentMetadata === null || currentMetadata.id !== metadata.id" @click="startEditing(metadata)" class="i-button p-2">
							<i class="far fa-edit"></i>
						</div>
						<div v-show="currentMetadata === null || currentMetadata.id !== metadata.id" @click="deleteMetadata(metadata)" class="i-button pl-2 py-2">
							<i class="far fa-trash-alt"></i>
						</div>
					</template>
				</li>
			</transition-group>
		</div>
	</div>
</template>

<script>
import {mask} from 'vue-the-mask'
import _ from 'lodash';

export default {
	props: ['source', 'sourceType'],
	data() {
		return {
			form: {
				label: '',
				value: '',
				sourceId: this.source.id,
				sourceType: this.sourceType,
			},
			isEditing: false,
			currentMetadata: null,
			metadataLabels: [],
			errors: [],
			randomId: "metadata-labels-"+(Math.random() + 1).toString(36).substring(7)
		}
	},
	mounted() {
		this.getDistinctMetadataLabels();
	},
	methods: {
		save() {
			this.errors = [];

			axios.post('/saveMetadata', this.form).then(response => {
				this.resetForm();

				var metadatas = this.source.metadatas;
				metadatas.unshift(response.data);

				const sortedMetadatas = _.sortBy(metadatas, (metadata) => metadata.label.toLowerCase());
				Vue.set(this.source, 'metadatas', sortedMetadatas);

				this.getDistinctMetadataLabels();
				this.updateMetadataCount();
			}).catch(error => {
				if (error.response.status === 422) {
					this.errors = error.response.data.errors || {};
				} else {
					console.log(error);
				}
			});
		},
		resetForm() {
			this.form.label = '';
			this.form.value = '';
			this.isEditing = false;
			this.currentMetadata = null;
			this.errors = [];
		},
		startEditing(metadata) {
			this.isEditing = true;
			this.currentMetadata = metadata;
			this.form.label = metadata.label;
			this.form.value = metadata.value;
			this.$refs.label.focus();
			this.errors = [];
		},
		finishEditing() {
			this.errors = [];
			this.form.metadataId = this.currentMetadata.id;

			axios.post('/editMetadata', this.form).then(response => {
				this.currentMetadata.label = this.form.label;
				this.currentMetadata.value = this.form.value;

				this.resetForm();

				this.getDistinctMetadataLabels();
			}).catch(error => {
				if (error.response.status === 422) {
					this.errors = error.response.data.errors || {};
				} else {
					console.log(error);
				}
			});
		},
		deleteMetadata(metadata) {
			axios.get('/deleteMetadata/' + metadata.id).then(response => {
				this.source.metadatas.splice(this.source.metadatas.indexOf(metadata), 1);
				this.getDistinctMetadataLabels();
				this.updateMetadataCount();
	        }).catch(err => {
	            console.log(err)
	        })
		},
		getDistinctMetadataLabels() {
			axios.get('/metadataLabels/' + this.sourceType).then(response => {
				this.metadataLabels = response.data;
				this.$refs.label.focus();
			});
		},
		updateMetadataCount() {
			if(this.sourceType === 'canvas') {
				this.$store.state.canvases.data.map(canvas => {
					if(this.source.id === canvas.id) {
						Vue.set(canvas, 'metadatas_count', this.source.metadatas.length);
					}
				});
			}
		},
	}
}
</script>
